import Typography from '@repo/ui/typography'

import { ApplicationStatusEnum } from '../../../lib/types/enums/enrollment/application-status.enum'
import { EnrollmentLight } from '../../../lib/types/models/enrollment/enrollment-light'
import { EnrollmentDetails, EnrollmentDetailsMode } from './enrollment-details'

type EnrollmentItemType = EnrollmentLight & { onView?: () => void }

type EnrollmentSectionType = {
  title: string
  data?: EnrollmentItemType[]
}

type EnrollmentSectionProps = { mode: EnrollmentDetailsMode } & EnrollmentSectionType

type Props = {
  mode: EnrollmentDetailsMode
  sections?: EnrollmentSectionType[]
}

/**
 * Filter enrollments by status
 * @param filterByStatus - The status to filter by
 * @param enrollments - The enrollments to filter
 * @returns The filtered enrollments
 */
export function filterEnrollmentsByStatus(
  filterByStatus: ApplicationStatusEnum,
  enrollments?: EnrollmentLight[]
) {
  if (!enrollments) return undefined
  let data = enrollments
  if (filterByStatus) data = data.filter((e) => e.status === filterByStatus)
  return data
}

/**
 * Enrollment section component which renders the trip details
 * @param title - The title of the section
 * @param data - The enrollments to display
 * @param mode - The mode of the enrollment details
 * @returns The enrollment section component
 */
function EnrollmentSection({ title, data, mode }: EnrollmentSectionProps) {
  if (!data || data.length === 0) return
  return (
    <div className={'flex flex-col gap-2'}>
      <Typography variant={'label-semibold'}>{title}</Typography>
      <div className={'grid grid-cols-3 gap-4'}>
        {data.map((enrollment) => (
          <EnrollmentDetails key={enrollment.id} mode={mode} enrollment={enrollment} />
        ))}
      </div>
    </div>
  )
}

/**
 * Enrollment details view component which renders the enrollment details
 * @param mode - The mode of the enrollment details
 * @param sections - The sections to display
 * @returns The enrollment details view component
 */
export function EnrollmentDetailsView({ mode, sections }: Props) {
  if (!sections || sections.length === 0)
    return <Typography variant={'label-semibold'}>Aucun séjour trouvé</Typography>

  return (
    <div className={'flex flex-col gap-4 p-6'}>
      {sections.map((section) => (
        <EnrollmentSection key={section.title} {...section} mode={mode} />
      ))}
    </div>
  )
}
